import _ from 'lodash'

import {
    FSTMT_CHANGE_DATA_TABLE_ACTIVE,
    FSTMT_GRAPH_CHANGE_YEAR,
    FSTMT_GET_RESULTS_DATA_REQUEST,
    FSTMT_CHANGE_CURRENT_STANDARD,
} from './constants'

import config from '../../config'

export function fstmtGraphChangeYear(module, id, blockKey, customData) {
    return {
        type: FSTMT_GRAPH_CHANGE_YEAR,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function fstmtChangeDataTableActive(module, id, blockKey, customData) {
    return {
        type: FSTMT_CHANGE_DATA_TABLE_ACTIVE,
        data: {
            module,
            id,
            blockKey,
            customData,
        },
    }
}

export function fstmtGetResultsDataRequest(module, blockKey, entId, qs) {
    return {
        type: FSTMT_GET_RESULTS_DATA_REQUEST(module, entId),
        payload: {
            ..._.get(config, `api.${module}.${blockKey}.results`),
            uriParams: {
                entId,
            },
            qs,
        },
    }
}

export function fstmtChangeCurrentStandard(module, id, blockKey, level, tableType, standardType) {
    return {
        type: FSTMT_CHANGE_CURRENT_STANDARD,
        data: {
            module,
            id,
            blockKey,
            level,
            tableType,
            standardType,
        },
    }
}
